import { Component, OnInit, Input } from '@angular/core';
import { ProductService } from '@app-services/product.service';
import { TranslateService } from '@ngx-translate/core';

interface PropertyCardInterface {
	price: number;
	address: string;
	squareFootage: number;
	bedrooms: number;
	bathrooms: string;
	imageUrl: string;
	lease: boolean;
	url: string;
}

@Component({
	selector: 'app-public-card-property',
	templateUrl: './public-card-property.component.html',
	styleUrls: ['./public-card-property.component.scss']
})
export class PublicCardPropertyComponent implements OnInit {
	@Input() property: PropertyCardInterface;
	@Input() size: 'small' | 'default' = 'default';
	@Input() nofollow = false;

	constructor(private readonly productService: ProductService, public readonly translate: TranslateService) {}

	ngOnInit(): void {
		this.productService.getProductInfo().subscribe(info => {
			this.translate.use(info.language);
		});
	}

	formatPrice(price: number): string {
		return price.toLocaleString('en-US', {
			style: 'currency',
			currency: 'USD'
		});
	}
}
